import { render, staticRenderFns } from "./sub_head.vue?vue&type=template&id=2c243d4e"
import script from "./sub_head.vue?vue&type=script&lang=js"
export * from "./sub_head.vue?vue&type=script&lang=js"
import style0 from "./sub_head.vue?vue&type=style&index=0&id=2c243d4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports